import { render, staticRenderFns } from "./TabContato.vue?vue&type=template&id=04008558&"
import script from "./TabContato.vue?vue&type=script&lang=js&"
export * from "./TabContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports